export default {
  activateTagSite(plate, serial){
    window.location = `/#/conta/resumo-ativacao-tag/${plate}/${serial}`;
  }
}



// WEBPACK FOOTER //
// ./src/mobile.js